import { type ReactNode } from 'react';

import { cn } from '@/lib/utils';

import { type MentionItem } from './mention';

export const mentionChipClassName = (selected = false) =>
  cn(
    'mx-0.5 inline-flex h-[1lh] max-w-[22rem] select-none items-center gap-1 rounded-full border border-grayA-5 bg-grayA-3 px-2.5 align-top font-medium text-foreground',
    selected && 'ring-1 ring-grayA-8'
  );

export const mentionChipTitle = ({ name, detail }: MentionItem) =>
  detail ? `${name} — ${detail}` : name;

export const MentionChipContent = ({
  mention,
  icon,
}: {
  mention: MentionItem;
  icon?: ReactNode;
}) => (
  <>
    {icon ??
      (mention.iconUrl ? (
        <img
          width={16}
          height={16}
          src={mention.iconUrl}
          alt=""
          className="rounded-[2px]"
        />
      ) : null)}
    <span className="min-w-0 truncate">{mention.name}</span>
    {mention.detail && (
      <span className="truncate font-normal text-foreground-subtle">
        · {mention.detail}
      </span>
    )}
  </>
);
